<template>
  <div v-if="item.type === 'text'">
    <pop-up-text-group :item="item" />
  </div>
  <div v-else-if="item.type === 'table'">
    <pop-up-table :item="item" />
  </div>
  <div v-else-if="item.type === 'datatable'">
    <PopUpDataTable :item="item" />
  </div>
  <div v-else-if="item.type === 'timeline'">
    <pop-up-time-line :item="item" />
  </div>
  <div v-else-if="item.type === 'docs'">
    <PopUpDocs :item="item" />
  </div>
  <div
    v-else-if="
      item.type === 'datatable_with_search' ||
      item.type === 'datatable_with_search_and_actions'
    "
  >
    <PopUpDataTableWithSearch
      ref="dataFetchable"
      :id="id"
      :itemprop="item"
      :updateDetailsData="refresher"
    />
  </div>
  <div v-else-if="item.type === 'datatable_with_object'">
    <PopUpDataTableObject
      ref="dataFetchable"
      :id="id"
      :itemprop="item"
      :updateDetailsData="refresher"
    />
  </div>
</template>

<script>
import PopUpDataTable from "@/own/components/fulfillment/orders/popup/PopUpDataTable.vue";
import PopUpTable from "@/own/components/fulfillment/orders/popup/PopUpTable.vue";
import PopUpTextGroup from "@/own/components/fulfillment/orders/popup/PopUpTextGroup.vue";
import PopUpDocs from "@/own/components/fulfillment/orders/popup/PopUpDocs.vue";
import PopUpTimeLine from "@/own/components/fulfillment/orders/popup/PopUpTimeLine.vue";
import PopUpDataTableWithSearch from "@/own/components/fulfillment/orders/popup/PopUpDataTableWithSearch.vue";
import PopUpDataTableObject from "@/own/components/fulfillment/orders/popup/PopUpDataTableObject.vue";

export default {
  name: "PopUpSelector",
  props: ["item", "id", "refresher", "toggleDetail", "deleteDocUrl"],
  components: {
    PopUpDataTable,
    PopUpTable,
    PopUpTextGroup,
    PopUpTimeLine,
    PopUpDocs,
    PopUpDataTableWithSearch,
    PopUpDataTableObject,
  },
  methods: {
    fetchData() {
      try {
        this.$refs?.dataFetchable?.getDataFromApi();
      } catch {
        return;
      }
    },
  },
};
</script>
